import { useEffect, useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { Button, CircularProgress, Paper, Typography } from "@mui/material";


function RobotStatus({ robot }){
    robot.messages.sort((a, b) => { return b.timestamp - a.timestamp});
    return (
        <>
            <Paper elevation={6} sx={{ padding: 4 }}>
                <Typography><b>{ robot.name }</b></Typography>
                <Typography display="inline" color={(new Date().getTime() - robot.timestamp) < 5000?"green":"red"}>{ robot.formattedTimestamp } - </Typography>
                <Typography display="inline" color={robot.running?"green":"red"}>{ robot.running?"Running":"Waiting" }</Typography>
                {
                    robot.messages.map(message => {
                        return (<Typography>
                            { message.timestampFormatted.substr(0, 19).replace("T", " ") + " " + message.message }
                        </Typography>)
                    })
                }
            </Paper>       
         </>
    )
}

export function RobotsList(){

    const [robotsList, setRobotsList] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);

    function refreshList(){
        setIsRefreshing(true);
        StorylineServerProxy.allRobotsStatus().then(robots => { setRobotsList(robots.robots); setIsRefreshing(false) });
    }

    useEffect(() => {
        refreshList();
    }, []);


    return (
        <>
            {
                isRefreshing?<CircularProgress />:<>
                    <Button onClick={refreshList}>Refresh list</Button>
                    {
                        robotsList.map(robot => {
                            return <RobotStatus robot={robot} />
                        })
                    }
                </>
            }
        </>
    )
}